/* eslint-disable import/first */
import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import * as config from "config/config";

class DeleteBordereau extends Component {
	constructor() {
		super();
	}
	componentDidMount() {
		config
			.apiFetch(config.Api_Url + "/delete/bordereau", {
				method: "POST",
				body: JSON.stringify({
					id_bordereau: this.props.match.params.id_bordereau,
				}),
				headers: { "Content-Type": "application/json" },
			})
			.then((response) => response.json())
			.then((data) => {
				if (data["data"].affectedRows != 0) {
					this.props.history.goBack();
				} else {
					this.props.history.push("/404");
				}
			});
	}
	render() {
		return null;
	}
}

export default withRouter(DeleteBordereau);
